module.exports = __webpack_public_path__ + "assets/img/image-57-320.c50a6a11.webp";